// extracted by mini-css-extract-plugin
export default {"subcontainer":"programming_subcontainer__wxFp3","title":"programming_title__su0pN","tooltipContent":"programming_tooltipContent__ZzZ18"};